(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: no-preference)');
  if (!motion.matches || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.08, rootMargin: '0px 0px 40px 0px' });

  const observe = (root = document) => {
    for (const section of root.querySelectorAll('.learn-page[data-learn-reveal]:not(.is-visible)')) observer.observe(section);
  };

  observe();
  document.documentElement.classList.add('learn-motion-ready');
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
